<template>
  <div class="flex">
    <p
      :class="`text-${textSize} font-medium metric-text`"
      v-html="metric"
    />
    <div
      v-if="tpConfig.content"
      v-tooltip="tpConfig"
      class="flex-shrink-0 w-5 h-5 mt-1 ml-2"
    >
      <QuestionCircleIcon class="w-full h-full" />
    </div>
  </div>
</template>

<script>
import { QuestionCircleIcon } from '@thehotelsnetwork/icons/vue/linear';

export default {
  components: {
    QuestionCircleIcon,
  },
  props: {
    metric: {
      type: String,
      default: 'Metric',
    },
    tpConfig: {
      type: Object,
      default: () => ({}),
    },
    textSize: {
      type: String,
      default: 'xl',
    },
  },
};
</script>

<style scoped>
  .metric-text {
    line-height: 1.7rem;
  }
</style>
